import React from 'react';
import { useAuth } from 'react-oidc-context';

const Profile: React.FC = () => {
  const auth = useAuth();
  const email = (auth.user?.profile as any)?.email ?? auth.user?.profile?.sub ?? '—';

  return (
    <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
      <h1 style={{ color: '#fff', marginBottom: '16px' }}>Profile</h1>
      <p style={{ color: '#9ca3af' }}>Email: {email}</p>
      <p style={{ color: '#6b7280', fontSize: '14px', marginTop: '24px' }}>
        Platform profile (bio, interests, city) — wire to GET/PUT /profile/me when backend is ready.
      </p>
    </div>
  );
};

export default Profile;
